import { REQUEST_MAPPING } from "@/common/constant";
import REQUEST from "@/common/api.service";

export const GET_CLASSIFICATION_REPORT_DATA = (params) =>
  REQUEST.post(REQUEST_MAPPING.CLASSIFICATION_REPORT + "/filter", params);

export const GET_CLASSIFICATION_REPORT_DATA_BY_MAJOR_CATEGORY = (params) =>
  REQUEST.post(
    REQUEST_MAPPING.CLASSIFICATION_REPORT + "/filter-by-major/major-code",
    params,
  );
export const GET_ALL_STORES = () => REQUEST.get(REQUEST_MAPPING.STORE + "/all");

export const GET_ALL_MIDDLE_CATEGORIES = () =>
  REQUEST.get(REQUEST_MAPPING.CATEGORIES + "/all-middle");

export const GET_ALL_MAJOR_CATEGORIES = () =>
  REQUEST.get(REQUEST_MAPPING.CATEGORIES + "/all-major");
